import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { DateHelper } from "@/Common/Helpers/DateHelper";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { BaseWorkSafeBcSubSection, IBaseWorkSafeBcSubSectionProps } from "../BaseWorkSafeBcSubSection";
import { WorkSafeBcWorkerModel } from "../Models/WorkSafeBcWorkerModel";

interface IWorkSafeBcWorkerSectionProps extends IBaseWorkSafeBcSubSectionProps {
    worker: WorkSafeBcWorkerModel;
}

class WorkSafeBcWorkerSection extends BaseWorkSafeBcSubSection<IWorkSafeBcWorkerSectionProps, never> {
    public render(): JSX.Element {
        const model = this.props.model;
        const worker = this.props.worker;
        const workerCountryId = worker.MailingAddress.CountryLookupId || this.canadaLookUpId;

        return (
            <div className="flex-grow-container subsection-border-left">
                <div className="row margin-sm-bottom">
                    {this.renderFields(
                        {
                            labelValueKey: "DateofBirthLabel",
                            value: DateHelper.formatDate(worker.BirthDate, this.dateFormat),
                            hasParentClassName: true,
                            className: "col-md-6",
                            isEditMode: false,
                            onReadOnlyClick: () => sessionStore.dispatch(LocalPatientOperations.Profile.DOBLabelClick),
                            required: true
                        }
                    )}
                    {this.renderFields(
                        {
                            labelValueKey: "WorkSafeBc_WorkSafeBcClaimNumberLabel",
                            value: model.ClaimNumber,
                            hasParentClassName: true,
                            className: "col-md-6"
                        },
                        <TextboxControl
                            onChange={value => this.props.mutateModelState(s => s.ClaimNumber = value)}
                            value={model.ClaimNumber}
                            maxLength={12}
                        />
                    )}
                </div>
                {this.renderFields(
                    {
                        labelValueKey: "WorkSafeBc_WorkerLastNameLabel",
                        value: worker.LastName,
                        isEditMode: false,
                        onReadOnlyClick: () => sessionStore.dispatch(LocalPatientOperations.Profile.PatientLastNameLabelClick),
                        required: true
                    }
                )}
                <div className="row margin-sm-bottom">
                    {this.renderFields(
                        {
                            labelValueKey: "FirstNameDLabel",
                            value: worker.FirstName,
                            hasParentClassName: true,
                            className: "col-md-6",
                            isEditMode: false,
                            onReadOnlyClick: () => sessionStore.dispatch(LocalPatientOperations.Profile.PatientFirstNameLabelClick),
                            required: true
                        }
                    )}
                    {this.renderFields(
                        {
                            labelValueKey: "WorkSafeBc_MiddleInitialLabel",
                            value: model.WorkerMiddleInitial,
                            hasParentClassName: true,
                            className: "col-md-3"
                        },
                        <TextboxControl
                            onChange={value => this.props.mutateModelState(s => s.WorkerMiddleInitial = value)}
                            value={model.WorkerMiddleInitial}
                            maxLength={4}
                        />
                    )}
                    {this.renderFields(
                        {
                            labelValueKey: "GenderLabel",
                            value: worker.Gender,
                            hasParentClassName: true,
                            className: "col-md-3",
                            isEditMode: false,
                            onReadOnlyClick: () => sessionStore.dispatch(LocalPatientOperations.Profile.PatientGenderLabelClick),
                            required: true
                        }
                    )}
                </div>
                {this.renderAddress(
                    "WorkSafeBc_MailingAddressLabel",
                    `WorkerMailingAddress_${this.props.formId}`,
                    worker.MailingAddress,
                    null,
                    true
                )}
                {this.renderFields(
                    {
                        labelValueKey: "WorkSafeBc_WorkerContactPhoneNumberLabel",
                        value: this.validationHelper.getFormattedPhoneNumberString(worker.PhoneNumber, workerCountryId),
                        isEditMode: false,
                        onReadOnlyClick: () => sessionStore.dispatch(
                            LocalPatientOperations.Profile.PhoneLabelClick,
                            { contactPointId: worker.PhoneNumberContactPointId }
                        )
                    }
                )}
                {this.renderFields(
                    {
                        labelValueKey: "WorkSafeBc_WorkerPersonalHealthNumberLabel",
                        value: worker.HealthCardNumber,
                        isEditMode: false,
                        onReadOnlyClick: () => sessionStore.dispatch(LocalPatientOperations.Profile.NAMLabelClick),
                        required: true
                    }
                )}
            </div>
        );
    }
}

export { WorkSafeBcWorkerSection };
